import type { UserProfile } from '@/lib/api/users';
import type { UserCredits } from '@/lib/stores/credits-store';
import { isOnboardingRequired } from '@/lib/onboarding';
import { isOnboardingProductRoute } from '@/lib/onboarding-product-route';

export function isWelcomeRewardSurface(pathname: string, userId: string | undefined, profile: UserProfile | null): boolean {
  return Boolean(userId && isOnboardingProductRoute(pathname)
    && profile?.user_id === userId && !isOnboardingRequired(profile));
}

export function shouldAutoShowWelcomeReward(surface: boolean, ready: boolean, accountId: string | null,
  userId: string | undefined, shown: boolean, credits: UserCredits | null): boolean {
  return Boolean(surface && ready && userId && accountId === userId && !shown && credits?.welcome_credit_status === 'pending');
}
